import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP4UnderUtilizedReorder202606: FaireAdPerformancePeriodEntity =
  {
    token: "perf_p4_under_utilized_reorder_202606",
    type: "adPerformancePeriod",
    scope: "REORDER_MARKETPLACE",
    periodType: "RECEIPT",
    startDate: "2026-06-01",
    endDate: "2026-06-30",
    impressions: 4416,
    clicks: 75,
    adsSpendDollars: 500,
    budgetDollars: 500,
    salesDollars: 2226,
    bestEstimateRoas: 4.45,
    bestEstimateType: "ACTUALIZED",
    budgetUtilization: 1,
    reorderConversions: 7,
    dataAvailableAtDate: "2026-07-04",
    meta: {
      source: "mock",
      importedAt: "2026-07-06T00:00:00.000Z",
      importedBy: "advertiser-profiles",
    },
  };
